import { Component, ChangeDetectionStrategy } from '@angular/core';
import { ButtonComponent, IconComponent } from '@claas/claas-ui-components';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-server-error',
  templateUrl: './server-error.component.html',
  styleUrls: ['./server-error.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ButtonComponent, IconComponent, TranslateModule],
})
export class ServerErrorComponent {
  /**
   * Reload the current page on click
   *
   * @method reload
   */
  reload(): void {
    window.location.reload();
  }
}
